import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Global error logging for debugging initialization errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise
  });
});

console.log('App initialization starting...');

createRoot(document.getElementById("root")!).render(<App />);
